var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"id":"logo-img","src":_vm.organisationStore.logo,"lazy-src":_vm.organisationStore.logo,"height":"50%","contain":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }